import React from 'react';
import { View, StyleSheet } from 'react-native';
import { LibraryView, AssessmentsView, SegmentsView, NodesView, BuilderView } from './builder';
import { EDITOR_COLORS } from '../../styles/editorTheme';

interface ProGroupsBuilderViewProps {
  storage?: any;
  apiService?: any;
  initialSubsection?: string;
}

type BuilderSubsection = 'Library' | 'Assessments' | 'Segments' | 'Nodes' | 'Builder';

const resolveBuilderSubsection = (initialSubsection?: string): BuilderSubsection => {
  switch (initialSubsection) {
    case 'Library':
    case 'Assessments':
    case 'Segments':
    case 'Nodes':
    case 'Builder':
      return initialSubsection;
    default:
      return 'Library';
  }
};

export const ProGroupsBuilderView: React.FC<ProGroupsBuilderViewProps> = ({
  initialSubsection,
}) => {
  const activeSubsection = resolveBuilderSubsection(initialSubsection);

  return (
    <View style={styles.container}>
      {activeSubsection === 'Library' ? (
        <LibraryView />
      ) : activeSubsection === 'Assessments' ? (
        <AssessmentsView />
      ) : activeSubsection === 'Segments' ? (
        <SegmentsView />
      ) : activeSubsection === 'Nodes' ? (
        <NodesView />
      ) : (
        <BuilderView />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: EDITOR_COLORS.background,
  },
});
